function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-pc{fill:#e20d1a;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Logo_Guidelines"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-pc",
  d: "M60.55,79.73a10.06,10.06,0,1,0-10-10.06A10.05,10.05,0,0,0,60.55,79.73Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-pc",
  d: "M110.65,149.14a10.06,10.06,0,1,0,10.06,10.06A10.05,10.05,0,0,0,110.65,149.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-pc",
  d: "M54.84,84.34v49.3a5.71,5.71,0,0,0,11.42,0V84.34a15.24,15.24,0,0,1-11.42,0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-pc",
  d: "M66.26,55V11.42h15a26.06,26.06,0,0,1,26,25.47,26.07,26.07,0,0,1-26,25.47H74.45a15.6,15.6,0,0,1,1.88,7.31,16,16,0,0,1-.61,4.11h5.57a37.49,37.49,0,0,0,37.35-35.16,5.47,5.47,0,0,0,.12-1.15c0-.2,0-.39,0-.58s0-.38,0-.58a5.47,5.47,0,0,0-.12-1.15A37.49,37.49,0,0,0,81.29,0H61l-.2,0-.2,0a5.71,5.71,0,0,0-5.71,5.71V55a15.37,15.37,0,0,1,11.42,0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-pc",
  d: "M95.93,164.73A51.37,51.37,0,0,1,17,148.64a51.35,51.35,0,0,1,22.65-69,49.7,49.7,0,0,1,6.9-2.86,14.77,14.77,0,0,1-1-11.58,60.85,60.85,0,0,0-11,4.25,62.78,62.78,0,0,0,8.75,115.67,62.73,62.73,0,0,0,60.32-11.9A15.72,15.72,0,0,1,95.93,164.73Z"
})));

var SvgPc = function SvgPc(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 120.71 188.27",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPc, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/PC.4d257ed6.svg";
export { ForwardRef as ReactComponent };